export enum EnumUFs {
  AC = 'Acre',
  AL = 'Alagoas',
  AP = 'Amapá',
  AM = 'Amazonas',
  BA = 'Bahia',
  CE = 'Ceará',
  DF = 'Distrito Federal',
  ES = 'Espírito Santo',
  GO = 'Goiás',
  MA = 'Maranhão',
  MT = 'Mato Grosso',
  MS = 'Mato Grosso do Sul',
  MG = 'Minas Gerais',
  PA = 'Pará',
  PB = 'Paraíba',
  PR = 'Paraná',
  PE = 'Pernambuco',
  PI = 'Piauí',
  RJ = 'Rio de Janeiro',
  RN = 'Rio Grande do Norte',
  RS = 'Rio Grande do Sul',
  RO = 'Rondônia',
  RR = 'Roraima',
  SC = 'Santa Catarina',
  SP = 'São Paulo',
  SE = 'Sergipe',
  TO = 'Tocantins',
}

export enum EnumForeignDocumentType {
  PASSPORT = 'PASSPORT',
  RNE = 'RNE',
}

export enum EnumWorkerType {
  PAR = 'Parada',
  ROT = 'Rotina',
}

export enum EnumNationality {
  BR = 'Brasileira (o)',
  GRINGO = 'Estrangeira (o)',
}

export enum EnumWorkplace {
  REFINARIA_SP = 'BA01',
}

export enum EnumOffice {
  BA01 = 'BA01',
}

export enum EnumWorkShift {
  ADM = 'ADM',
  TURNO = 'TURNO'
}
